import Vue from "vue"
import App from "./App.vue"
import router from "./router"
import store from "./store"
import { post, get } from "@/api/requrestHttp"
import _ from "lodash"
import Print from "@/utils/pulgs/print"
import my from '@/assets/css/my.css'
window.TumsPlayer = window['tums-player'].default;
Vue.prototype._ = _

Vue.prototype.$post = post
Vue.prototype.$get = get
// import axios from 'axios'
import request from "@/utils/request"
import request2 from "@/utils/request2"
import request3 from "@/utils/request3"
import dayjs from "dayjs"
Vue.prototype.$day = dayjs
import vueSwiper from "vue-awesome-swiper"
import "swiper/dist/css/swiper.css"
Vue.use(vueSwiper)
Vue.use(Print)
import VueBus from 'vue-bus'
Vue.use(VueBus)
import AudioPlayer from '@liripeng/vue-audio-player'
Vue.use(AudioPlayer)
import Video from "video.js"
import "video.js/dist/video-js.css"
import "videojs-flash"
Vue.prototype.$video = Video
import EZUIKit from "ezuikit-js"
// import Viewer from 'v-viewer'
// import 'viewerjs/dist/viewer.css'
// Vue.use(Viewer)
// Viewer.setDefaults({
//   Options: {
//     'inline': true,
//     'button': true,
//     'navbar': true,
//     'title': true,
//     'toolbar': true,
//     'tooltip': true,
//     'movable': true,
//     'zoomable': true,
//     'rotatable': true,
//     'scalable': true,
//     'transition': true,
//     'fullscreen': true,
//     'keyboard': true,
//     'url': 'data-source'
//   }
// })

import "./assets/css/normalize.css" /*引入样式初始化文件*/
import "./assets/css/global.css" /*引入全局样式 */
import "./assets/font/font.css"

import ElementUI from "element-ui"
import "element-ui/lib/theme-chalk/index.css"
Vue.use(ElementUI)
// 编辑插件
import quillEditor from "vue-quill-editor"
import "quill/dist/quill.core.css"
import "quill/dist/quill.snow.css"
import "quill/dist/quill.bubble.css"
Vue.use(quillEditor)

require("echarts-amap")
import scroll from "vue-seamless-scroll"
Vue.use(scroll)
// 图片预览
// import vuePicturePreview from "vue-picture-preview"
// Vue.use(vuePicturePreview)
import preview from "vue-photo-preview"
import "vue-photo-preview/dist/skin.css"
let options = {
  fullscreenEl: false
}
Vue.use(preview, options)

Vue.use(preview)

import animated from "animate.css" // npm install animate.css --save安装，在引入
Vue.use(animated)
import dayin from "vue-print-nb"
import VueParticles from "vue-particles"
Vue.use(VueParticles)
Vue.use(dayin)
import "./filter/filter" // 引入filter 过滤器
Vue.prototype.$http = request // use this.$http to send request for all page
Vue.prototype.request2 = request2
Vue.prototype.request3 = request3
// 引入echarts
import echarts from "echarts"
import "echarts-gl"
Vue.prototype.$echarts = echarts
// 工单导入
Vue.prototype.uploadInfo = function(event, pgdtype) {
  const file = event.target.files[0]
  console.log(file)
  const formData = new FormData()
  formData.append("file", file)
  // formData.append('belongProvinceId', this.belongProvinceId || '')
  formData.append("belongProvinceId", "")
  formData.append("belongAddressId", "1856cf78-bd6a-45bf-afd4-b553f3da443f")
  formData.append("pgdtype", pgdtype)
  request({
    url: "/jjyl/servicePgd/info/ServicePgdExcel",
    method: "POST",
    data: formData
  }).then(res => {
    // 清除上传记录
    const fileEle = document.getElementById("speechUpload")
    fileEle.value = ""
    if (res.code === 200) {
      this.$message.success("上传成功")
      this.getDataList()
    } else {
      this.$message.error("上传失败")
    }
  })
}

// import Print from "@/utils/pulgs/print"
// Vue.use(Print)

import visibility from "vue-visibility-change"
Vue.use(visibility)

// 全局挂载事件总线
Vue.prototype.$Bus = new Vue()

Vue.config.productionTip = false

// 注册一个全局自定义指令
Vue.directive("permission", {
  // 当被绑定的元素插入到 DOM 中时……
  inserted: function(el, binding) {
    // console.log(binding)
    // console.log(el)
    // console.log(store.state)
    // console.log(store.state.permission.includes(binding.value.sign))
    let v = binding.value.sign || binding.value
    if (store.state.permission.includes(v)) {
    } else {
      // el.disabled = true
      // el.classList.add("is-disabled")
      el.style.display = "none"
    }
  }
})
//注册一个全局重复点击自定义指令
Vue.directive("preventDbClick", {
  inserted: function(el, binding) {
    el.addEventListener("click", () => {
      if (!el.disabled) {
        el.disabled = true
        setTimeout(() => {
          el.disabled = false
        }, 2000)
      }
    })
  }
})
// 字典
import { getDicts } from "@/api/system/data"

import {
  parseTime,
  resetForm,
  addDateRange,
  selectDictLabel,
  download,
  handleTree
} from "@/utils/utils"
Vue.prototype.getDicts = getDicts
Vue.prototype.parseTime = parseTime
Vue.prototype.resetForm = resetForm
Vue.prototype.addDateRange = addDateRange
Vue.prototype.selectDictLabel = selectDictLabel
Vue.prototype.download = download
Vue.prototype.handleTree = handleTree
Vue.prototype.msgSuccess = function(msg) {
  this.$message({
    showClose: true,
    message: msg,
    type: "success"
  })
}

//定义vm
const vm = new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app")

visibility.change((evt, hidden) => {
  if (
    localStorage.token &&
    sessionStorage.getItem("tokens") &&
    localStorage.token != sessionStorage.getItem("tokens")
  ) {
    vm.$router.push("/login")
  }
})

export default vm
